import React from 'react';
import PropTypes from 'prop-types';
import { lessonTypeLabel, lessonTimeLabel, polishDate } from './clientPortalSelectors';
import { BillingSummary, PackageCard, AssociationNotice } from './PortalCards';

export default function ClientDashboard({ data, client, hasStudents, lessonTypes, renderLesson, link }) {
  return (
    <>
      {!hasStudents && <p className="client-portal__card">Brak przypisanych uczniów</p>}
      <div className={`client-portal__summary-grid${hasStudents ? '' : ' client-portal__summary-grid--payer'}`}>
        {hasStudents && (
        <section className="client-portal__card client-portal__nearest"><h2>Najbliższa lekcja</h2>
          {data.nearest ? renderLesson(data.nearest) : <p>Brak nadchodzących, nieodwołanych lekcji</p>}
        </section>
        )}
        <div><BillingSummary ledger={data.ledger} client={client} />{link('billing', 'Przejdź do rozliczeń →')}</div>
      </div>
      {hasStudents && (
      <section className="client-portal__card"><div className="client-portal__section-heading"><h2>Harmonogram</h2>{link('schedule', 'Zobacz harmonogram →')}</div>
        {data.schedulePreview.map(lesson => (
          <article className="client-portal__schedule-preview" key={`${lesson.lessonId}-${lesson.studentId}`}>
            <strong>{polishDate(lesson.date)}</strong><span>{lessonTimeLabel(lesson, lessonTypes)}</span><span>{lesson.studentName}</span>
            <span>{lessonTypeLabel(lesson.classTypeId, lessonTypes)}</span>
            {lesson.lessonStatus === 'cancelled' && <span>Lekcja odwołana</span>}
            {lesson.lessonStatus !== 'cancelled' && String(lesson.participationStatus).startsWith('cancelled') && <span>Udział odwołany</span>}
          </article>
        ))}
        {!data.schedule.length && <p>Brak nadchodzących lekcji</p>}
      </section>
      )}
      {hasStudents && (
      <section className="client-portal__card"><div className="client-portal__section-heading"><h2>Pakiety</h2>{link('packages', 'Wszystkie pakiety →')}</div>
        {data.unknownAssociations.packages && <AssociationNotice />}
        {data.packagePreview.map(item => <PackageCard key={item.id} item={item} lessonTypes={lessonTypes} />)}
        {!data.packages.length && !data.unknownAssociations.packages && <p>Brak pakietów</p>}
      </section>
      )}
    </>
  );
}
ClientDashboard.propTypes = {
  data: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  hasStudents: PropTypes.bool.isRequired,
  lessonTypes: PropTypes.array.isRequired,
  renderLesson: PropTypes.func.isRequired,
  link: PropTypes.func.isRequired,
};
